import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { SkeletonMeetPurpose } from "../../Skeleton Loading/SkeletonMeetPurpose";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadCountryData } from "../../../redux/action";
import { SBSaveUpdateBtn } from "../../SbButtons/SbAddBtn";

function RegionCountryTable(props) {
    let tableHeader = [
        { name: "Country Name", align: "left", width: "200px" },
        // { name: "Zone Name", align: "left", width: "200px" },
        // { name: "State Name", align: "left", width: "200px" },
        // { name: "City Name", align: "left", width: "2000px" },
    ];

    let dispatch = useDispatch();
    const { getCountryName } = useSelector((state) => state.data);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        dispatch(loadCountryData())
    }, [])

    return (
        <>
            {/* <h4 className="accounts-header" >Passbook</h4> */}
            <div className="sb-table-div sb-table-setion">
                <Paper
                    sx={{ width: "100%", overflow: "hidden" }}
                    className="table-main-div"
                >
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table
                            stickyHeader
                            aria-label="sticky table table-responsive"
                            className="basefare-table"
                        >
                            <TableHead className="custom-table-header">
                                <TableRow>
                                    {tableHeader.map((name, i) => (
                                        <TableCell
                                            key={i}
                                            align={name.align}
                                            className={`thead-cell-products`}
                                            style={{ minWidth: name.width }}
                                        >
                                            {name.name}
                                        </TableCell>
                                    ))}
                                    {/* <TableCell>
                                        <SBSaveUpdateBtn
                                            btnName="Add Country"
                                            onClickEffect={props.openModal}
                                        />
                                    </TableCell> */}
                                </TableRow>
                            </TableHead>
                            {isLoading ? (
                                <>
                                    {tableHeader.map((name, i) => (
                                        <SkeletonMeetPurpose key={i} />
                                    ))}
                                </>
                            ) : (
                                <>
                                    {getCountryName &&
                                        getCountryName.length === 0 ? (
                                        <TableBody>
                                            <TableRow align="center">
                                                <TableCell align="center" colSpan={tableHeader.length}>
                                                    <div style={{ padding: "20px 20px" }}>
                                                        <img
                                                            src="../../../../images/DefaultImages/NodataFound.jpg"
                                                            alt=""
                                                            style={{ width: "10%" }}
                                                        />
                                                        <br />
                                                        <span>No Data Found...!</span>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            {getCountryName && getCountryName.map((data, index) => (
                                                <TableRow
                                                    align="center"
                                                    key={index}
                                                    className="client-list-row-data"
                                                >
                                                    <TableCell>
                                                        <div className="table-row-head-Text">
                                                            {/* {data.countryName} */}
                                                            {data.label}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    )}
                                </>
                            )}
                        </Table>
                    </TableContainer>
                </Paper>
            </div >
        </>
    );
}

export default RegionCountryTable;
